import React from "react"
import { Link } from "gatsby"
import MENU from '../styles/components/menu.module.scss'


const Menu = ({ nodes }) => {
    const array = [];

    nodes.forEach((node,i) => {
        array[i] = 
        <li key={node.label+i} label={node.label}>
            <Link to={node.url} activeClassName="active">
                <span>{node.label}</span>
            </Link>
        </li>        
    })
    
return (<ul className={MENU.MENU}>{[array]}</ul>)
}

export default Menu
